// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Map_wrapper__2P40H","mapWrapper":"Map_mapWrapper__1A5IB","map":"Map_map__c0SrZ"};